import styled from 'styled-components';

export const LoadingCSS = styled.div`
  .ui.dimmer {
    background-color: rgba(0,0,0,.65);
    position: fixed;
  }
`;